import React from "react"

import { testIds } from "../../common/constants"
import useLinksTo from "../../hooks/use-links-to"

import pages from "../../redirection/pages.json"
import contentfulIds from "../../common/contentful-ids"
import Link from "../link"

const blogPath = pages[contentfulIds.blog]
const portfolioPath = pages[contentfulIds.portfolio]

const MainNavigation = ({
  className = "",
  linkClassName = "",
  activeLinkClassName = "",
  pages = [],
  onClickPage,
  tabIndex = 0,
}) => {
  const handleClick = to => {
    const regexp = new RegExp(`^${to}/?$`)
    const hasClickedCurrentPage = regexp.test(window.location.pathname)
    if (hasClickedCurrentPage) {
      onClickPage()
    }

    // bugfix for going to blog/portfolio, clicking some category (or not), scrolling down, and then clicking blog/portfolio from the menu
    // please also see gatsby-browser.js for scroll behavior changes
    const hasClickedBasePathPage = window.location.pathname.startsWith(to)
    const hasClickedBlogOrPortfolio =
      to.startsWith(blogPath) || to.startsWith(portfolioPath)
    const shouldScrollToTop =
      hasClickedBlogOrPortfolio && hasClickedBasePathPage

    if (shouldScrollToTop) {
      window.scroll(0, 0)
    }
  }

  const { getPageTo } = useLinksTo()

  return (
    <nav className={className}>
      {pages.map(page => (
        <Link
          key={page.id}
          to={getPageTo(page.slug)}
          className={linkClassName}
          activeClassName={activeLinkClassName}
          partiallyActive={true}
          tabIndex={tabIndex}
          onClick={() => handleClick(getPageTo(page.slug))}
          data-test-id={testIds.global.header.navigation.menu.item}
        >
          {page.title}
        </Link>
      ))}
    </nav>
  )
}

export default MainNavigation
